import React, { Dispatch, SetStateAction } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const ProfileContext = React.createContext({
    showProfileDropdown: false,
    showEditProfile: false,
    setUserStartedTour: (() => {}) as Dispatch<SetStateAction<boolean>>,
    handleHideOnboarding: () => {}
});
